package org.moxultimate.topwithmox.wallpaper.data

import kotlinx.serialization.Serializable

/**
 * Response DTO for GET /wallpaper-series.
 * Maps to the Spring WallpaperSeriesEntity returned by the series lookup table.
 */
@Serializable
data class WallpaperSeriesEntity(
    val id: Long = 0,
    val series: String,
)
